import { proxy, ref } from "valtio"
import { deepClone } from "valtio/utils"
import type { ConnectOption } from "../flow/ConnectFlow/ConnectModal/components/WalletLogin/useConnectOptions"

// -- Helpers -------------------------------------------------------
const CONNECT_MODEL_STEP_TITLES: Record<
  ConnectModalStepId,
  ConnectModalStepTitle
> = {
  "pick-login-option": "connectWithOpenSea",
  "more-wallet-options": "moreWalletOptions",
  "acknowledge-email-signup": "acknowledgeEmailSignup",
  "enter-email-auth-code": "enterEmailAuthCode",
  "verify-auth-code": "verifyAuthCode",
  "select-ecosystem": "connectWithOpenSea",
}

const INITIAL_STEP_ID: ConnectModalStepId = "pick-login-option"

const INITIAL_STEP = { id: INITIAL_STEP_ID }

// -- Types ---------------------------------------------------------
type ConnectModalStepId =
  | "pick-login-option"
  | "acknowledge-email-signup"
  | "enter-email-auth-code"
  | "verify-auth-code"
  | "more-wallet-options"
  | "select-ecosystem"

type ConnectModalStepTitle =
  | "connectWithOpenSea"
  | "moreWalletOptions"
  | "acknowledgeEmailSignup"
  | "enterEmailAuthCode"
  | "verifyAuthCode"

type EmailLoginStep = {
  id: "acknowledge-email-signup" | "enter-email-auth-code" | "verify-auth-code"
  email: string
}

type PickLoginOptionStep = {
  id: "pick-login-option"
  email?: string
}

type MoreWalletOptionsStep = {
  id: "more-wallet-options"
}

type SelectEcosystemStep = {
  id: "select-ecosystem"
  connectOption: ConnectOption
}

type ConnectModalStep =
  | EmailLoginStep
  | PickLoginOptionStep
  | MoreWalletOptionsStep
  | SelectEcosystemStep

type ConnectModalStateType = {
  step: ConnectModalStep
  title: ConnectModalStepTitle
}

// -- State ---------------------------------------------------------
const INITIAL_STATE: ConnectModalStateType = {
  step: INITIAL_STEP,
  title: CONNECT_MODEL_STEP_TITLES[INITIAL_STEP.id],
}

export const ConnectModalState = proxy<ConnectModalStateType>(
  deepClone(INITIAL_STATE),
)

// -- Actions -------------------------------------------------------
export const ConnectModalActions = {
  setStep(step: ConnectModalStep) {
    ConnectModalState.step = ref({ ...ConnectModalState.step, ...step })
    ConnectModalState.title = CONNECT_MODEL_STEP_TITLES[step.id]
  },

  reset(timeout = 300) {
    // Use a timeout to allow the modal to close before resetting the state
    setTimeout(() => {
      ConnectModalState.step = INITIAL_STEP
      ConnectModalState.title = CONNECT_MODEL_STEP_TITLES[INITIAL_STEP.id]
    }, timeout)
  },
}
